import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnVS } from '..';
import { leagueRequiresRound } from './league-config';

type FormData = FormDataOf<typeof disneyEspnVS>;

export const shouldShowField = (fieldKey: string, formData: FormData): boolean => {
  if (fieldKey === 'round') return leagueRequiresRound(formData.league);
  return true;
};
